import { Injectable, signal } from '@angular/core';
import { environment } from '../environments';
import { Stage } from '../enums';
import { STORAGE_KEY } from './environment-hint.config';

/**
 * Shared state for the "Show Environment Hint" user preference.
 *
 * Backed by `localStorage` so the value persists across reloads and is
 * shared between the user-settings toggle and the app banner.
 */
@Injectable({ providedIn: 'root' })
export class EnvironmentHintService {
    private readonly _showEnvironmentHint = signal<boolean>(this.readInitialValue());

    public readonly showEnvironmentHint = this._showEnvironmentHint.asReadonly();

    public toggle(): void {
        const value = !this._showEnvironmentHint();
        this._showEnvironmentHint.set(value);
        localStorage.setItem(STORAGE_KEY, String(value));
    }

    private readInitialValue(): boolean {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored !== null) {
            return stored === 'true';
        }
        return environment.stage !== Stage.PROD;
    }
}
